import { Alert, AlertTitle } from '@mui/material'

import { useTexts } from '../../../useTexts'
import { useValues } from './hooks/useValues'

import { form } from '../../../formState'

export function UnsubscribeInstructions() {
  const { showWarningCard, notificationWay } = useValues()
  const texts = useTexts()

  const warningCardText =
    notificationWay === 'EMAIL'
      ? texts.unsubscribeInstructionsAlertTextEmail
      : texts.unsubscribeInstructionsAlertTextPhone

  return (
    <>
      {notificationWay === 'EMAIL' ? (
        <>
          <form.Checkbox
            key="includeMessageUnsubscriptionInstructionsEmail"
            helperText={texts.unsubscribeInstructionsHelperText(notificationWay)}
            name="includeMessageUnsubscriptionInstructionsEmail"
            testId="includeMessageUnsubscriptionInstructionsEmail"
            label={texts.unsubscribeInstructionsLabel}
            validateOn="focus blur"
          />

          {showWarningCard && (
            <Alert severity="warning">
              <AlertTitle>{texts.unsubscribeInstructionsAlertTitle}</AlertTitle>
              {warningCardText}
            </Alert>
          )}
        </>
      ) : (
        <form.Checkbox
          key="includeMessageUnsubscriptionInstructionsPhone"
          helperText={texts.unsubscribeInstructionsHelperText(notificationWay)}
          name="includeMessageUnsubscriptionInstructionsPhone"
          testId="includeMessageUnsubscriptionInstructionsPhone"
          label={texts.unsubscribeInstructionsLabel}
          validateOn="focus blur"
          disabled
        />
      )}
    </>
  )
}
